import createComponentInternal from './createComponent';
import * as _ from 'lodash';
var createComponent = function (_a) {
    var displayName = _a.displayName, render = _a.render;
    return createComponentInternal({
        displayName: displayName,
        render: function (config, props) {
            var filteredConfig = _.pick(config, ['classes', 'rtl']);
            return render(Object.assign({ stardust: filteredConfig }, props));
        },
    });
};
export default createComponent;
